import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './Feed.module.scss';
import { POST_ITEMS_TYPES } from '@/utils/constants';
import FeedCollection from '@/components/features/feed/FeedCollection/FeedCollection';
import Loader, { ICoreLoaderProps } from '@/components/core/Loader/Loader';
import FeedHeader from '@/components/features/feed/FeedHeader/FeedHeader';
import { withTranslation, WithTranslation } from 'next-i18next';
import { InView } from 'react-intersection-observer';
import StoryFeedItem from '@/components/features/feed/StoryFeedItem/StoryFeedItem';
import FeedNews from '@/components/features/feed/FeedNews/FeedNews';
import { NextSeo } from 'next-seo';
import { getImageUrl, size } from '@/utils/attachment';
import { ellipsis } from '@/utils/string-util';
import { PostItemTypes } from '@/utils/enums';

export const FEED_THEMES = {
	HOME: 'Home',
	COLLECTION: 'Collection',
	USER: 'User',
	STORY: 'Story',
};

interface IFeedProps extends WithTranslation {
	headerActionType: string;
	onCloseTo: string;
	headerTitle: string;
	headerSubtitle: string;
	theme: string;
	loaderType: ICoreLoaderProps['type'];
	items: Array<any>;
	isReachingEnd: boolean;
	isLoadingMore: boolean;
	onLoadMore: () => void;
}

class Feed extends Component<IFeedProps> {
	getFeedElement(item) {
		switch (POST_ITEMS_TYPES[item.type]) {
			case PostItemTypes.COLLECTION:
				return <FeedCollection data={item} />;
			case PostItemTypes.NEWS:
				return <FeedNews data={item} />;
			case PostItemTypes.STORY:
				return <StoryFeedItem data={item} />;
			default:
				return null;
		}
	}

	render() {
		const {
			headerActionType,
			headerTitle,
			headerSubtitle,
			onCloseTo,
			theme,
			loaderType,
			items,
			onLoadMore,
			isLoadingMore,
			isReachingEnd,
		} = this.props;

		const contentClassName = classNames(styles.feedContent, 'js-modal-overlay');

		const feedClassNames = classNames(styles.feed, styles[`feed${theme}`]);

		return (
			<div className={feedClassNames}>
				<NextSeo
					title={items?.[0].title}
					openGraph={{
						title: items?.[0].title,
						description: ellipsis(items?.[0].content),
						images: [
							{
								url: getImageUrl(items?.[0].image, size.FACEBOOK),
								alt: 'Brokenships',
							},
						],
					}}
				/>
				<div className={styles.feedHeader}>
					<FeedHeader
						onCloseTo={onCloseTo}
						title={headerTitle}
						subtitle={headerSubtitle}
						visibleActionType={headerActionType}
					/>
				</div>
				<div className={contentClassName}>
					{items.map((item) => this.getFeedElement(item))}

					<InView
						onChange={(inView) => {
							if (inView && !isReachingEnd && !isLoadingMore) {
								onLoadMore?.();
							}
						}}
					>
						{isLoadingMore ? (
							<div className={styles.feedLoader}>
								<Loader type={loaderType} />
							</div>
						) : null}
					</InView>
				</div>
			</div>
		);
	}
}

export default withTranslation()(Feed);
